module.exports = __webpack_public_path__ + "img/strelitzia_oiseau_de_paradis.bbab4a10.jpg";